"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavigationLinks = void 0;
const libs_router_link_utils_1 = require("@hotelplan/libs.router-link-utils");
const getNavigationLinks = (navMenu) => {
    const navLinks = navMenu
        .map(navItem => {
        if (navItem && navItem.__typename === 'TextMenuItem') {
            const label = navItem.caption;
            const iconType = navItem.iconType;
            const link = (0, libs_router_link_utils_1.getRouterLink)(navItem.link);
            return {
                label,
                link,
                iconType,
                target: (0, libs_router_link_utils_1.getOpenMethod)(navItem.link),
                fontColor: navItem.fontColor,
            };
        }
        if (navItem && navItem.__typename === 'Menu') {
            const link = (0, libs_router_link_utils_1.getRouterLink)(navItem.target);
            const label = navItem.caption;
            const entries = navItem.entries ? navItem.entries : [];
            const subLinks = entries
                .map(entry => {
                if (!entry)
                    return;
                const { caption, iconType } = entry;
                return {
                    label: caption,
                    iconType: iconType,
                    link: (0, libs_router_link_utils_1.getRouterLink)(entry.link),
                    target: (0, libs_router_link_utils_1.getOpenMethod)(entry.link),
                    fontColor: navItem.fontColor,
                };
            })
                .filter(Boolean);
            return {
                link,
                label,
                subLinks,
                target: (0, libs_router_link_utils_1.getOpenMethod)(navItem.target),
                fontColor: navItem.fontColor,
            };
        }
        return;
    })
        .filter(Boolean);
    return navLinks;
};
exports.getNavigationLinks = getNavigationLinks;
//# sourceMappingURL=Menu.mappers.js.map